import { PropertyValueDto } from "./PropertyValueDto";

export class OrderDto {
    public Level: string;
    constructor(public OrderEntityId: number, public OrderRecordId: number, public PropertyValues: PropertyValueDto[], public Price : number, public Quantity: number) { }
}